export function MetricCard({ label, value, sub, icon: Icon, accent = "forest", testId }) {
  const accentClass = accent === "terracotta" ? "bg-terracotta/10 text-terracotta" : accent === "sage" ? "bg-sage/15 text-forest" : "bg-forest/10 text-forest";
  return (
    <div className="card-flat p-6" data-testid={testId}>
      <div className="flex items-start justify-between mb-4">
        <div className="label">{label}</div>
        {Icon && (
          <div className={`w-9 h-9 rounded-md grid place-items-center ${accentClass}`}>
            <Icon className="w-4 h-4" strokeWidth={1.5} />
          </div>
        )}
      </div>
      <div className="metric tabular-nums">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-2">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8" data-testid={testId}>
      <div>
        <div className="label mb-2">{subtitle || "Overview"}</div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight">{title}</h1>
      </div>
      {actions}
    </div>
  );
}

export function Section({ title, children, actions, testId }) {
  return (
    <section className="card-flat p-6 mb-6" data-testid={testId}>
      {(title || actions) && (
        <div className="flex items-center justify-between mb-4">
          {title && <h3 className="font-display text-lg font-semibold tracking-tight">{title}</h3>}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}

export function Pill({ children, variant = "default" }) {
  const cls = {
    default: "bg-muted text-foreground",
    success: "bg-forest/10 text-forest",
    warning: "bg-terracotta/10 text-terracotta",
    info: "bg-sage/20 text-foreground",
  }[variant] || "bg-muted text-foreground";
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] tracking-[0.15em] uppercase font-semibold ${cls}`}>{children}</span>;
}
